module.exports = __webpack_public_path__ + "img/shidu3.gif";